import { render, staticRenderFns } from "./AddForkTruckDialog.vue?vue&type=template&id=3ce92a95&scoped=true&"
import script from "./AddForkTruckDialog.vue?vue&type=script&lang=js&"
export * from "./AddForkTruckDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddForkTruckDialog.vue?vue&type=style&index=0&id=3ce92a95&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce92a95",
  null
  
)

export default component.exports